import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';

import { Card, Spinner } from '../../components/ui';
import { api } from '../../lib/api';
import { formatDateTime } from '../../lib/formatters';

export function ClubHome() {
  const { slug } = useParams<{ slug: string }>();
  const { data, isLoading } = useQuery({
    queryKey: ['clubHome', slug],
    queryFn: async () => (await api.get(`/public/${slug}`)).data,
    enabled: !!slug,
  });

  if (isLoading) return <Spinner />;
  if (!data) return <div className="p-6">Club not found.</div>;

  return (
    <div className="min-h-screen bg-cream-100">
      <header
        className="text-cream-100 px-6 py-8"
        style={{ background: data.org.primaryColor ?? '#0F1E3C' }}
      >
        <div className="max-w-4xl mx-auto flex items-center gap-4">
          {data.org.logoUrl && <img src={data.org.logoUrl} alt={data.org.name} className="h-12" />}
          <h1 className="font-display italic text-3xl">{data.org.name}</h1>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-6 py-8 space-y-4">
        <h2 className="font-display text-2xl">Upcoming events</h2>
        {(data.events ?? []).length === 0 ? (
          <Card className="p-5 text-center text-ink-muted">No events scheduled.</Card>
        ) : (
          <ul className="space-y-3">
            {data.events.map((ev: any) => (
              <li key={ev.id}>
                <Link to={`/${slug}/events/${ev.id}`}>
                  <Card className="p-5 hover:shadow-cardHover transition">
                    <div className="font-medium">{ev.title}</div>
                    <div className="text-sm text-ink-muted">{formatDateTime(ev.startTime)}</div>
                  </Card>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </main>
    </div>
  );
}
